import type { VideoItem } from '@/mocks/videos';

interface VideoInfoProps {
  video: VideoItem;
}

export default function VideoInfo({ video }: VideoInfoProps) {
  return (
    <div>
      <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
        {video.title}
      </h1>

      <div className="flex flex-wrap items-center gap-3 mb-4">
        <span className="px-3 py-1 bg-primary-100 text-primary-700 text-sm font-semibold rounded-md">
          {video.rating} 分
        </span>
        <span className="text-sm text-foreground-500">{video.year}</span>
        <span className="text-sm text-foreground-500">{video.region}</span>
        <span className="text-sm text-foreground-500">{video.duration}</span>
        <span className="text-sm text-foreground-500">{video.episodeInfo}</span>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {video.tags.map((tag) => (
          <span
            key={tag}
            className="px-3 py-1 bg-secondary-100 text-secondary-700 text-xs rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6 p-4 bg-background-100 rounded-lg">
        <div>
          <p className="text-xs text-foreground-500 mb-1">导演</p>
          <p className="text-sm font-medium text-foreground-900">{video.director}</p>
        </div>
        <div className="col-span-2 sm:col-span-2">
          <p className="text-xs text-foreground-500 mb-1">主演</p>
          <p className="text-sm font-medium text-foreground-900">{video.actors.join(' / ')}</p>
        </div>
        <div>
          <p className="text-xs text-foreground-500 mb-1">语言</p>
          <p className="text-sm font-medium text-foreground-900">{video.language}</p>
        </div>
        <div>
          <p className="text-xs text-foreground-500 mb-1">更新时间</p>
          <p className="text-sm font-medium text-foreground-900">{video.updateDate}</p>
        </div>
        <div>
          <p className="text-xs text-foreground-500 mb-1">播放量</p>
          <p className="text-sm font-medium text-foreground-900">{(video.views / 10000).toFixed(0)}万次</p>
        </div>
      </div>

      <div className="mb-6">
        <h2 className="text-base font-heading font-bold text-foreground-900 mb-3">剧情简介</h2>
        <div
          className="text-sm text-foreground-700 leading-relaxed space-y-3"
          dangerouslySetInnerHTML={{ __html: video.contentHtml }}
        />
      </div>
    </div>
  );
}